let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4XBpR")).then(() => parcelRequire('2dcG3'));